// Homepage hero slider: slides push sideways like a banner carousel.
// Arrows, dots, keyboard, swipe that follows the finger, and autoplay.
// Autoplay pauses on hover, on keyboard focus, while a finger is down and
// while the tab is in the background, and never starts if the visitor
// asked for less motion.
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(root) {
    if (root.__heroReady) return;
    root.__heroReady = true;

    var stage = root.querySelector('[data-stage]');
    var viewport = root.querySelector('.herox__viewport') || root;
    var slides = [].slice.call(root.querySelectorAll('[data-slide]'));
    if (!stage || slides.length < 2) return;

    var dots = [].slice.call(root.querySelectorAll('[data-dot]'));
    var delay = (parseInt(root.getAttribute('data-autoplay'), 10) || 0) * 1000;
    var rtl = document.documentElement.dir === 'rtl';
    var index = 0;
    var timer = null;
    var paused = false;

    function paint() {
      stage.style.setProperty('--hx', index);
      slides.forEach(function (slide, i) {
        var on = i === index;
        if (on) { slide.setAttribute('data-active', ''); } else { slide.removeAttribute('data-active'); }
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) { slide.removeAttribute('inert'); } else { slide.setAttribute('inert', ''); }
      });
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function show(next) {
      var count = slides.length;
      index = ((next % count) + count) % count;
      paint();
    }

    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    function start() {
      stop();
      if (paused || !delay || REDUCED.matches || document.hidden) return;
      timer = window.setInterval(function () { show(index + 1); }, delay);
    }

    function jump(next) {
      show(next);
      start();
    }

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-prev]')) { jump(index - 1); return; }
      if (event.target.closest('[data-next]')) { jump(index + 1); return; }
      var dot = event.target.closest('[data-dot]');
      if (dot) jump(dots.indexOf(dot));
    });

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      var towardEnd = event.key === 'ArrowRight';
      if (rtl) towardEnd = !towardEnd;
      jump(towardEnd ? index + 1 : index - 1);
    });

    ['mouseenter', 'focusin'].forEach(function (type) {
      root.addEventListener(type, function () { paused = true; stop(); });
    });
    ['mouseleave', 'focusout'].forEach(function (type) {
      root.addEventListener(type, function () { paused = false; start(); });
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    // Swipe. The track follows the finger sideways; the page still scrolls
    // up and down because the viewport only claims horizontal pans.
    var startX = 0;
    var startY = 0;
    var dx = 0;
    var dragging = false;
    var decided = false;

    function endDrag(commit) {
      if (!dragging) return;
      dragging = false;
      root.classList.remove('is-dragging');
      stage.style.setProperty('--drag', '0px');
      if (commit && Math.abs(dx) > 50) {
        var forward = rtl ? dx > 0 : dx < 0;
        jump(forward ? index + 1 : index - 1);
      } else {
        paused = false;
        start();
      }
    }

    viewport.addEventListener('touchstart', function (event) {
      var t = event.touches[0];
      startX = t.clientX;
      startY = t.clientY;
      dx = 0;
      dragging = true;
      decided = false;
      paused = true;
      stop();
    }, { passive: true });

    viewport.addEventListener('touchmove', function (event) {
      if (!dragging) return;
      var t = event.touches[0];
      var mx = t.clientX - startX;
      var my = t.clientY - startY;
      if (!decided) {
        if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
        decided = true;
        if (Math.abs(my) > Math.abs(mx)) { dragging = false; paused = false; start(); return; }
        root.classList.add('is-dragging');
      }
      dx = mx;
      stage.style.setProperty('--drag', dx + 'px');
    }, { passive: true });

    viewport.addEventListener('touchend', function () { endDrag(true); }, { passive: true });
    viewport.addEventListener('touchcancel', function () { endDrag(false); }, { passive: true });

    paint();
    start();
  }

  function init() {
    document.querySelectorAll('[data-hero]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor re-renders the section on every change.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-hero]');
    if (root) setup(root);
  });
})();
